module.exports = __webpack_public_path__ + "static/media/info_chats.e1c86c32.svg";